export default __webpack_public_path__ + "static/media/EquilibriumImg.9cc5d618.jpg";